import React from 'react';
export function CrossCircleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.832 9.176a1 1 0 00-1.414 0L12 10.586l-1.41-1.417a1 1 0 10-1.416 1.412L10.586 12 9.17 13.41a1 1 0 101.412 1.416L12 13.414l1.41 1.416a1 1 0 101.416-1.412L13.414 12l1.416-1.41a1 1 0 00.002-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.082 4.94A9.931 9.931 0 0012.016 2H12a10 10 0 00-.016 20H12a10 10 0 007.082-17.06zm-1.434 12.725A7.944 7.944 0 0112 20h-.013A8 8 0 1112 4h.012a8 8 0 015.636 13.665z"
  }));
}